/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect} from 'react';
import {View} from 'react-native';
import SecondaryButton from '../../components/Button/SecondaryButton';
import { styles } from './styles';
import Label from '../../components/Label';
import { Footer } from '../../components/Footer/Footer';
import { InputField } from '../../components/Inputs/InputField';
import { TitleLabels } from '../../../data/constants/login';
import { Validation } from '../../../common/utils/validation';
import { useForm } from '../../../hooks/Login/useForm';

export const Form = (props: any) => {
  const {
    data,
    listAgence,
    onCancelForm,
    onSubmitForm,
    error,
    insciptionAction,
  } = props;

  const {
    handleChange,
    handleSubmit,
    values,
    errors,
    showErrors,
    dto,
    showError,
  } = useForm(data, Validation, handleCancel, handleSave, listAgence);

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    onSubmitForm(dto.data);
  }

  useEffect(() => {}, [data, values]);

  return (
    <View style={styles.container}>
      <View>
        <InputField
          label={TitleLabels.contractant.email}
          required
          value={values.email}
          name="email"
          onChange={handleChange}
          error={errors.email}
          showError={showErrors.email}
          maxLength={50}
          onSubmitEditing={handleSubmit}
        />
        <InputField
          label={TitleLabels.contractant.password}
          required
          type="password"
          value={values.password}
          name="password"
          onChange={handleChange}
          error={errors.password}
          showError={showErrors.password}
          maxLength={50}
          onSubmitEditing={handleSubmit}
        />
      </View>
      {showError && <Label title={error} type="error" />}
      {/** Submit buttons */}
      <View>
        <SecondaryButton
          cancelAction={handleCancel}
          underlineType={true}
          submitAction={handleSubmit}
          cancelTitle="Mot de passe oublié"
          submitTitle="Se connecter"
        />
      </View>
      <Footer creerCompte={insciptionAction} />
    </View>
  );
};
